import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../services/store/userSlice";
import ManagerDashboard from "./manager-dashboard";
import EmployeeDashboard from "./employee-dashboard";
import { NewAllocation } from "../allocation/newAllocation";
import { USER_MAINTENANCE_MENU_ACTION_ROLE_VIEW, APPLICATION_EMPLOYEE } from '../../config/permissions'
import { hasPermission } from "../../components/protected/ProtectedSection";
import "./style.scss";
import "./style1.scss";

const Dashboard = () => {
  const user = useSelector(selectUser);
  const [isEmployeeDashboard, setDashboard] = useState(false);
  const [showNewAllocation, setShowNewAllocation] = useState(false);
  const [reqMgrAlloc, setReqMgrAlloc] = useState(false);
  const [isUser, setIsUser] = useState(false);

  useEffect(() => {
    if (hasPermission(USER_MAINTENANCE_MENU_ACTION_ROLE_VIEW)) {
      setIsUser(true)
    }
    // if (hasPermission(APPLICATION_EMPLOYEE)) {
    //   setDashboard(true)
    // }
    const exists = user.roles.includes('PM');
    setDashboard(exists);
  }, []);

  const dashboardRefresh = () => { window.location.reload(false); };

  return (
    <div>
      <NewAllocation
        mode={isEmployeeDashboard}
        show={showNewAllocation}
        setShow={setShowNewAllocation}
        dashboardRefresh={dashboardRefresh}
        reqMgrAlloc={reqMgrAlloc}
      />
      {!isEmployeeDashboard || isUser ? (
        <EmployeeDashboard setNewAlloc={setShowNewAllocation} />
      ) : (
        <ManagerDashboard
          setNewAlloc={setShowNewAllocation}
          setReqMgrAlloc={setReqMgrAlloc}
        />
      )}
    </div>
  );
};

export default Dashboard;
